import React from 'react'
import PropTypes from 'prop-types'

import useBrandColour from '@hooks/useBrandColour'

import {
  Box, ListItem, Text,
} from '@domain-group/suit-theme'

const BrandColours = (props) => {
  const {
    brandColour,
    brandColour: {
      cmyk: {
        c, m, y, k,
      },
      rgb: {
        r, g, b,
      },
      spot_colour_name,
      title,
    },
  } = props

  const brandColourPayload = useBrandColour(brandColour)
  const {
    callbacks: { createOrEditBrandColour },
  } = brandColourPayload

  return (
    <ListItem
      boxProps={{
        as: 'a', alignItems: 'center', borderBottom: '1px dashed', fontSize: 'small', padding: 'large',
      }}
      onClick={() => createOrEditBrandColour()}
      showAngleIcon
    >
      <Box
        backgroundColor={`rgb(${r}, ${g}, ${b})`}
        border="1px solid"
        borderColor="lineColor"
        borderRadius="50%"
        flexShrink={0}
        height={18}
        marginRight="large"
        width={18}
      />

      <Box flexDirection="column">
        <Text color="bodyFontColor" variant="ellipsis">
          {title}
        </Text>

        <Box display={['none', 'flex']} flexDirection="column">
          <Text color="bodyFontLightColor" variant="ellipsis">
            C:{c} M:{m} Y:{y} K:{k}
          </Text>

          <Text color="bodyFontLightColor" variant="ellipsis">
            R:{r} G:{g} B:{b}
          </Text>

          <Text color="bodyFontLightColor" variant="ellipsis">
            {spot_colour_name}
          </Text>
        </Box>
      </Box>
    </ListItem>
  )
}

BrandColours.propTypes = {
  brandColour: PropTypes.shape({
    cmyk: PropTypes.object.isRequired,
    rgb: PropTypes.object.isRequired,
    spot_colour_name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
}

export default BrandColours
